import FormatChange from '../onformatchange-source';
window.FormatChange = FormatChange;
export default FormatChange;
